<template>
    <v-layout>
        <v-flex>
            <v-card>
                <v-card-title>
                    <h3 class="headline mb-0 admin-header">Org Approvals</h3>
                    <v-btn text icon color="grey lighten-1" @click="refresh(pagination)"><v-icon>fas fa-sync</v-icon></v-btn>
                </v-card-title>
                <v-card-text>
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-data-table
                              :items="orgApprovals"
                              :loading="loading"
                              :headers="headers"
                                class="elevation-1"
                            >
                              <template v-slot:item.orgName="{item}">
                                <td>
                                    <router-link to="" @click.native="editItem(item)">{{item.orgName}}</router-link>
                                </td>
                              </template>
                              <template v-slot:item.allowedDomains="{item}">
                                <td>{{item.allowedDomains}}</td>
                              </template>
                              <template v-slot:item.updatedDate="{item}">
                                <td>{{formatDateTime(item.updatedDate)}}</td>
                              </template>
                              <template v-slot:item.deleted="{item}">
                                <td>{{item.deleted ? 'yes' : 'no' }}</td>
                              </template>
                              <template v-slot:item.actions="{item}">
                                <td>
                                    <v-btn text icon @click="editItem(item)" style="height: 0px; width: 0px; padding-right:2px;">
                                        <v-icon color="grey lighten-1" style="font-size: 18px;" >fas fa-pencil</v-icon>
                                    </v-btn>
                                    <v-spacer></v-spacer>
                                    <v-btn text icon @click="deleteItem(item)" style="height: 0px; width: 0px; padding-right:2px;">
                                        <v-icon color="grey lighten-1" style="font-size: 18px;" >fas fa-trash</v-icon>
                                    </v-btn>
                                </td>
                              </template>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary" @click="newItem()">New Org Approval</v-btn>
                </v-card-actions>
            </v-card>
            <v-dialog v-model="showEditDialog" max-width="600px">
                <v-card>
                    <v-card-title>
                    <span class="headline">Org Approval</span>
                    </v-card-title>

                    <v-card-text>
                        <v-form v-model="validItem" @submit.prevent>
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex v-if="editedItem.id" xs12 class="subheading">
                                   Id: {{editedItem.id}} ({{editedItem.orgName}})
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                    <v-text-field v-model="editedItem.orgName" :rules="[rules.required]" label="Org Name"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                    <v-text-field v-model="editedItem.allowedDomains" :rules="[rules.required]" label="Allowed Domains"></v-text-field>
                                </v-flex>
                                <v-flex xs3>
                                    <v-checkbox v-model="editedItem.deleted" label="Deleted"></v-checkbox>
                                </v-flex>
                            </v-layout>
                        </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn class="mr-4" color="primary" outlined rounded  @click.native="close">{{'Cancel'}}</v-btn>
                        <v-btn color="primary" rounded :disabled="!validItem" @click.native="save">Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-flex>
    </v-layout>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import _ from 'lodash'
import moment from 'moment'
import Utility from './utility'
export default {
    computed: {
        ...mapGetters('user', {
            organizations: 'getOrganizationsTextValue',
            isSUPro: 'isSUPro'
        }),
        ...mapGetters('menus', {
          findRouteTitle: 'findRouteTitle'
        }),
        routeTitle: {
          get() {
            return this.findRouteTitle(this.$route.name) || this.title
          }
        }
    },
    data() {
        return {
            orgApprovals: [],
            loading: false,
            search: '',
            pagination : {
                    descending: true,
                    page: 1,
                    rowsPerPage: 10, // -1 for All",
                    itemsPerPage: 10,
                    sortBy: ["updatedDate"]
            },
            totalItems: 0,
            headers: [
                {text: 'Id', align: 'left', sortable: true, value: 'id'},
                {text: 'Org Name', align: 'left', sortable: true, value: 'orgName'},
                {text: 'Allowed Domains', align: 'left', sortable: true, value: 'allowedDomains'},
                {text: 'Updated Date', align: 'left', sortable: true, value: 'updatedDate'},
                {text: 'Updated By', align: 'left', sortable: true, value: 'updatedBy'},
                {text: 'Deleted', align: 'left', sortable: true, value: 'deleted'},
                {text: 'Actions', align: 'left', sortable: false, value: 'actions'}
            ],
            rules: {
                required: value => !!value || 'Required.',
                numeric: value => !value || Number.isInteger(+value) || 'Invalid format'
            },
            valid: false,
            validItem: false,
            showEditDialog: false,
            originalItem: null,
            editedItem: {
                id: -1,
                orgName: '',
                allowedDomains: ''
            },
            defaultItem: {
                id: null,
                orgName: '',
                allowedDomains: ''
            }
        }
    },
    watch: {
        pagination: {
            async handler () {
                await this.refresh(this.pagination)
            }, deep: true
        }
    },
    mounted: function() {
      this.refresh(this.pagination);
    },
    methods: {
        async refresh(pagination) {

            this.loading = true

            this.orgApprovals = await this.$store.dispatch('crossorg/getOrgApprovals')

            this.totalItems = this.orgApprovals.length

            this.loading = false
        },
        formatDateTime(val) {
            return moment(val).isValid() ? moment(val).format('MM/DD/YYYY, h:mm:ss a') : val
        },
        async editItem (item) {
            this.originalItem = item
            this.editedItem = Object.assign({}, item)
            this.showEditDialog = true
        },
        close() {
            this.showEditDialog = false
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.originalItem = null
            }, 300)
        },
        async save () {

            let newEditedItem = this.editedItem
            newEditedItem = Object.assign({}, this.editedItem)
            await this.$store.dispatch("crossorg/upsertOrgApproval", {orgApproval: newEditedItem})
            this.close()

            await this.refresh(this.pagination)
        },
        newItem() {
            this.editedItem = Object.assign({}, this.defaultItem)
            this.originalItem = null
            this.showEditDialog = true
        },
        async deleteItem(item) {
            if (confirm('Do you wish to permanently delete this item?')) {
                await this.$store.dispatch("crossorg/deleteOrgApproval", {orgApproval: item})
                await this.refresh(this.pagination)
            }
        }
    }
}
</script>
